import * as z from "@radix-ui/react-dialog";
import * as n from "react";
import { Primitive as C } from "@radix-ui/react-primitive";
import { useId as P } from "@radix-ui/react-id";
import { composeRefs as j } from "@radix-ui/react-compose-refs";
var se = 1, ke = 0.9, Se = 0.8, Ie = 0.17, Z = 0.1, _ = 0.999, xe = 0.9999, Re = 0.99, Ce = /[\\\/_+.#"@\[\(\{&]/, Ae = /[\\\/_+.#"@\[\(\{&]/g, Me = /[\s-]/, ve = /[\s-]/g;
function te(t, l, r, f, u, c, d) {
  if (c === l.length) return u === t.length ? se : Re;
  var m = `${u},${c}`;
  if (d[m] !== void 0) return d[m];
  for (var b = f.charAt(c), i = r.indexOf(b, u), p = 0, h, I, E, x; i >= 0; ) h = te(t, l, r, f, i + 1, c + 1, d), h > p && (i === u ? h *= se : Ce.test(t.charAt(i - 1)) ? (h *= Se, E = t.slice(u, i - 1).match(Ae), E && u > 0 && (h *= Math.pow(_, E.length))) : Me.test(t.charAt(i - 1)) ? (h *= ke, x = t.slice(u, i - 1).match(ve), x && u > 0 && (h *= Math.pow(_, x.length))) : (h *= Ie, u > 0 && (h *= Math.pow(_, i - u))), t.charAt(i) !== l.charAt(c) && (h *= xe)), (h < Z && r.charAt(i - 1) === f.charAt(c + 1) || f.charAt(c + 1) === f.charAt(c) && r.charAt(i - 1) !== f.charAt(c)) && (I = te(t, l, r, f, i + 1, c + 2, d), I * Z > h && (h = I * Z)), h > p && (p = h), i = r.indexOf(b, i + 1);
  return d[m] = p, p;
}
function fe(t) {
  return t.toLowerCase().replace(ve, " ");
}
function $e(t, l, r) {
  return t = r && r.length > 0 ? `${t + " " + r.join(" ")}` : t, te(t, l, fe(t), fe(l), 0, 0, {});
}
var V = '[cmdk-group=""]', ee = '[cmdk-group-items=""]', De = '[cmdk-group-heading=""]', pe = '[cmdk-item=""]', me = `${pe}:not([aria-disabled="true"])`, re = "cmdk-item-select", F = "data-value", Fe = (t, l, r) => $e(t, l, r), he = n.createContext(void 0), L = () => n.useContext(he), ge = n.createContext(void 0), ne = () => n.useContext(ge), be = n.createContext(void 0), we = n.forwardRef((t, l) => {
  let r = K(() => {
    var e, o;
    return { search: "", value: (o = (e = t.value) != null ? e : t.defaultValue) != null ? o : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), f = K(() => /* @__PURE__ */ new Set()), u = K(() => /* @__PURE__ */ new Map()), c = K(() => /* @__PURE__ */ new Map()), d = K(() => /* @__PURE__ */ new Set()), m = ye(t), { label: b, children: i, value: p, onValueChange: h, filter: I, shouldFilter: E, loop: x, disablePointerSelection: H = !1, vimBindings: A = !0, ...O } = t, N = P(), le = P(), T = P(), M = n.useRef(null), w = He();
  $(() => {
    if (p !== void 0) {
      let e = p.trim();
      r.current.value = e, k.emit();
    }
  }, [p]), $(() => {
    w(6, ue);
  }, []);
  let k = n.useMemo(() => ({ subscribe: (e) => (d.current.add(e), () => d.current.delete(e)), snapshot: () => r.current, setState: (e, o, s) => {
    var a, v, g, S;
    if (!Object.is(r.current[e], o)) {
      if (r.current[e] = o, e === "search") X(), G(), w(1, J);
      else if (e === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let y = document.getElementById(T);
          y ? y.focus() : (a = document.getElementById(N)) == null || a.focus();
        }
        if (w(7, () => {
          var y;
          r.current.selectedItemId = (y = D()) == null ? void 0 : y.id, k.emit();
        }), s || w(5, ue), ((v = m.current) == null ? void 0 : v.value) !== void 0) {
          let y = o ?? "";
          (S = (g = m.current).onValueChange) == null || S.call(g, y);
          return;
        }
      }
      k.emit();
    }
  }, emit: () => {
    d.current.forEach((e) => e());
  } }), []), W = n.useMemo(() => ({ value: (e, o, s) => {
    var a;
    o !== ((a = c.current.get(e)) == null ? void 0 : a.value) && (c.current.set(e, { value: o, keywords: s }), r.current.filtered.items.set(e, ae(o, s)), w(2, () => {
      G(), k.emit();
    }));
  }, item: (e, o) => (f.current.add(e), o && (u.current.has(o) ? u.current.get(o).add(e) : u.current.set(o, /* @__PURE__ */ new Set([e]))), w(3, () => {
    X(), G(), r.current.value || J(), k.emit();
  }), () => {
    c.current.delete(e), f.current.delete(e), r.current.filtered.items.delete(e);
    let s = D();
    w(4, () => {
      X(), s?.getAttribute("id") === e && J(), k.emit();
    });
  }), group: (e) => (u.current.has(e) || u.current.set(e, /* @__PURE__ */ new Set()), () => {
    c.current.delete(e), u.current.delete(e);
  }), filter: () => m.current.shouldFilter, label: b || t["aria-label"], getDisablePointerSelection: () => m.current.disablePointerSelection, listId: N, inputId: T, labelId: le, listInnerRef: M }), []);
  function ae(e, o) {
    var s, a;
    let v = (a = (s = m.current) == null ? void 0 : s.filter) != null ? a : Fe;
    return e ? v(e, r.current.search, o) : 0;
  }
  function G() {
    if (!r.current.search || m.current.shouldFilter === !1) return;
    let e = r.current.filtered.items, o = [];
    r.current.filtered.groups.forEach((a) => {
      let v = u.current.get(a), g = 0;
      v.forEach((S) => {
        let y = e.get(S);
        g = Math.max(y, g);
      }), o.push([a, g]);
    });
    let s = M.current;
    q().sort((a, v) => {
      var g, S;
      let y = a.getAttribute("id"), B = v.getAttribute("id");
      return ((g = e.get(B)) != null ? g : 0) - ((S = e.get(y)) != null ? S : 0);
    }).forEach((a) => {
      let v = a.closest(ee);
      v ? v.appendChild(a.parentElement === v ? a : a.closest(`${ee} > *`)) : s.appendChild(a.parentElement === s ? a : a.closest(`${ee} > *`));
    }), o.sort((a, v) => v[1] - a[1]).forEach((a) => {
      var v;
      let g = (v = M.current) == null ? void 0 : v.querySelector(`${V}[${F}="${encodeURIComponent(a[0])}"]`);
      g?.parentElement.appendChild(g);
    });
  }
  function J() {
    let e = q().find((s) => s.getAttribute("aria-disabled") !== "true"), o = e?.getAttribute(F);
    k.setState("value", o || void 0);
  }
  function X() {
    var e, o, s, a;
    if (!r.current.search || m.current.shouldFilter === !1) {
      r.current.filtered.count = f.current.size;
      return;
    }
    r.current.filtered.groups = /* @__PURE__ */ new Set();
    let v = 0;
    for (let g of f.current) {
      let S = (o = (e = c.current.get(g)) == null ? void 0 : e.value) != null ? o : "", y = (a = (s = c.current.get(g)) == null ? void 0 : s.keywords) != null ? a : [], B = ae(S, y);
      r.current.filtered.items.set(g, B), B > 0 && v++;
    }
    for (let [g, S] of u.current) for (let y of S) if (r.current.filtered.items.get(y) > 0) {
      r.current.filtered.groups.add(g);
      break;
    }
    r.current.filtered.count = v;
  }
  function ue() {
    var e, o, s;
    let a = D();
    a && (((e = a.parentElement) == null ? void 0 : e.firstChild) === a && ((s = (o = a.closest(V)) == null ? void 0 : o.querySelector(De)) == null || s.scrollIntoView({ block: "nearest" })), a.scrollIntoView({ block: "nearest" }));
  }
  function D() {
    var e;
    return (e = M.current) == null ? void 0 : e.querySelector(`${pe}[aria-selected="true"]`);
  }
  function q() {
    var e;
    return Array.from(((e = M.current) == null ? void 0 : e.querySelectorAll(me)) || []);
  }
  function Y(e) {
    let o = q()[e];
    o && k.setState("value", o.getAttribute(F));
  }
  function Q(e) {
    var o;
    let s = D(), a = q(), v = a.findIndex((S) => S === s), g = a[v + e];
    (o = m.current) != null && o.loop && (g = v + e < 0 ? a[a.length - 1] : v + e === a.length ? a[0] : a[v + e]), g && k.setState("value", g.getAttribute(F));
  }
  function ie(e) {
    let o = D(), s = o?.closest(V), a;
    for (; s && !a; ) s = e > 0 ? ze(s, V) : Ue(s, V), a = s?.querySelector(me);
    a ? k.setState("value", a.getAttribute(F)) : Q(e);
  }
  let oe = () => Y(q().length - 1), ce = (e) => {
    e.preventDefault(), e.metaKey ? oe() : e.altKey ? ie(1) : Q(1);
  }, de = (e) => {
    e.preventDefault(), e.metaKey ? Y(0) : e.altKey ? ie(-1) : Q(-1);
  };
  return n.createElement(C.div, { ref: l, tabIndex: -1, ...O, "cmdk-root": "", onKeyDown: (e) => {
    var o;
    (o = O.onKeyDown) == null || o.call(O, e);
    let s = e.nativeEvent.isComposing || e.keyCode === 229;
    if (!(e.defaultPrevented || s)) switch (e.key) {
      case "n":
      case "j": {
        A && e.ctrlKey && ce(e);
        break;
      }
      case "ArrowDown": {
        ce(e);
        break;
      }
      case "p":
      case "k": {
        A && e.ctrlKey && de(e);
        break;
      }
      case "ArrowUp": {
        de(e);
        break;
      }
      case "Home": {
        e.preventDefault(), Y(0);
        break;
      }
      case "End": {
        e.preventDefault(), oe();
        break;
      }
      case "Enter": {
        e.preventDefault();
        let a = D();
        if (a) {
          let v = new Event(re);
          a.dispatchEvent(v);
        }
      }
    }
  } }, n.createElement("label", { "cmdk-label": "", htmlFor: W.inputId, id: W.labelId, style: Te }, b), U(t, (e) => n.createElement(ge.Provider, { value: k }, n.createElement(he.Provider, { value: W }, e))));
}), Ke = n.forwardRef((t, l) => {
  var r, f;
  let u = P(), c = n.useRef(null), d = n.useContext(be), m = L(), b = ye(t), i = (f = (r = b.current) == null ? void 0 : r.forceMount) != null ? f : d?.forceMount;
  $(() => {
    if (!i) return m.item(u, d?.id);
  }, [i]);
  let p = Ee(u, c, [t.value, t.children, c], t.keywords), h = ne(), I = R((w) => w.value && w.value === p.current), E = R((w) => i || m.filter() === !1 ? !0 : w.search ? w.filtered.items.get(u) > 0 : !0);
  n.useEffect(() => {
    let w = c.current;
    if (!(!w || t.disabled)) return w.addEventListener(re, x), () => w.removeEventListener(re, x);
  }, [E, t.onSelect, t.disabled]);
  function x() {
    var w, k;
    H(), (k = (w = b.current).onSelect) == null || k.call(w, p.current);
  }
  function H() {
    h.setState("value", p.current, !0);
  }
  if (!E) return null;
  let { disabled: A, value: O, onSelect: N, forceMount: le, keywords: T, ...M } = t;
  return n.createElement(C.div, { ref: j(c, l), ...M, id: u, "cmdk-item": "", role: "option", "aria-disabled": !!A, "aria-selected": !!I, "data-disabled": !!A, "data-selected": !!I, onPointerMove: A || m.getDisablePointerSelection() ? void 0 : H, onClick: A ? void 0 : x }, t.children);
}), Pe = n.forwardRef((t, l) => {
  let { heading: r, children: f, forceMount: u, ...c } = t, d = P(), m = n.useRef(null), b = n.useRef(null), i = P(), p = L(), h = R((E) => u || p.filter() === !1 ? !0 : E.search ? E.filtered.groups.has(d) : !0);
  $(() => p.group(d), []), Ee(d, m, [t.value, t.heading, b]);
  let I = n.useMemo(() => ({ id: d, forceMount: u }), [u]);
  return n.createElement(C.div, { ref: j(m, l), ...c, "cmdk-group": "", role: "presentation", hidden: h ? void 0 : !0 }, r && n.createElement("div", { ref: b, "cmdk-group-heading": "", "aria-hidden": !0, id: i }, r), U(t, (E) => n.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": r ? i : void 0 }, n.createElement(be.Provider, { value: I }, E))));
}), qe = n.forwardRef((t, l) => {
  let { alwaysRender: r, ...f } = t, u = n.useRef(null), c = R((d) => !d.search);
  return !r && !c ? null : n.createElement(C.div, { ref: j(u, l), ...f, "cmdk-separator": "", role: "separator" });
}), Ve = n.forwardRef((t, l) => {
  let { onValueChange: r, ...f } = t, u = t.value != null, c = ne(), d = R((i) => i.search), m = R((i) => i.selectedItemId), b = L();
  return n.useEffect(() => {
    t.value != null && c.setState("search", t.value);
  }, [t.value]), n.createElement(C.input, { ref: l, ...f, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": b.listId, "aria-labelledby": b.labelId, "aria-activedescendant": m, id: b.inputId, type: "text", value: u ? t.value : d, onChange: (i) => {
    u || c.setState("search", i.target.value), r?.(i.target.value);
  } });
}), je = n.forwardRef((t, l) => {
  let { children: r, label: f = "Suggestions", ...u } = t, c = n.useRef(null), d = n.useRef(null), m = R((i) => i.selectedItemId), b = L();
  return n.useEffect(() => {
    if (d.current && c.current) {
      let i = d.current, p = c.current, h, I = new ResizeObserver(() => {
        h = requestAnimationFrame(() => {
          let E = i.offsetHeight;
          p.style.setProperty("--cmdk-list-height", E.toFixed(1) + "px");
        });
      });
      return I.observe(i), () => {
        cancelAnimationFrame(h), I.unobserve(i);
      };
    }
  }, []), n.createElement(C.div, { ref: j(c, l), ...u, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": m, "aria-label": f, id: b.listId }, U(t, (i) => n.createElement("div", { ref: j(d, b.listInnerRef), "cmdk-list-sizer": "" }, i)));
}), Le = n.forwardRef((t, l) => {
  let { open: r, onOpenChange: f, overlayClassName: u, contentClassName: c, container: d, ...m } = t;
  return n.createElement(z.Root, { open: r, onOpenChange: f }, n.createElement(z.Portal, { container: d }, n.createElement(z.Overlay, { "cmdk-overlay": "", className: u }), n.createElement(z.Content, { "aria-label": t.label, "cmdk-dialog": "", className: c }, n.createElement(we, { ref: l, ...m }))));
}), Oe = n.forwardRef((t, l) => R((r) => r.filtered.count === 0) ? n.createElement(C.div, { ref: l, ...t, "cmdk-empty": "", role: "presentation" }) : null), Be = n.forwardRef((t, l) => {
  let { progress: r, children: f, label: u = "Loading...", ...c } = t;
  return n.createElement(C.div, { ref: l, ...c, "cmdk-loading": "", role: "progressbar", "aria-valuenow": r, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": u }, U(t, (d) => n.createElement("div", { "aria-hidden": !0 }, d)));
}), Xe = Object.assign(we, { List: je, Item: Ke, Input: Ve, Group: Pe, Separator: qe, Dialog: Le, Empty: Oe, Loading: Be });
function ze(t, l) {
  let r = t.nextElementSibling;
  for (; r; ) {
    if (r.matches(l)) return r;
    r = r.nextElementSibling;
  }
}
function Ue(t, l) {
  let r = t.previousElementSibling;
  for (; r; ) {
    if (r.matches(l)) return r;
    r = r.previousElementSibling;
  }
}
function ye(t) {
  let l = n.useRef(t);
  return $(() => {
    l.current = t;
  }), l;
}
var $ = typeof window > "u" ? n.useEffect : n.useLayoutEffect;
function K(t) {
  let l = n.useRef();
  return l.current === void 0 && (l.current = t()), l;
}
function R(t) {
  let l = ne(), r = () => t(l.snapshot());
  return n.useSyncExternalStore(l.subscribe, r, r);
}
function Ee(t, l, r, f = []) {
  let u = n.useRef(), c = L();
  return $(() => {
    var d;
    let m = (() => {
      var i;
      for (let p of r) {
        if (typeof p == "string") return p.trim();
        if (typeof p == "object" && "current" in p) return p.current ? (i = p.current.textContent) == null ? void 0 : i.trim() : u.current;
      }
    })(), b = f.map((i) => i.trim());
    c.value(t, m, b), (d = l.current) == null || d.setAttribute(F, m), u.current = m;
  }), u;
}
var He = () => {
  let [t, l] = n.useState(), r = K(() => /* @__PURE__ */ new Map());
  return $(() => {
    r.current.forEach((f) => f()), r.current = /* @__PURE__ */ new Map();
  }, [t]), (f, u) => {
    r.current.set(f, u), l({});
  };
};
function Ne(t) {
  let l = t.type;
  return typeof l == "function" ? l(t.props) : "render" in l ? l.render(t.props) : t;
}
function U({ asChild: t, children: l }, r) {
  return t && n.isValidElement(l) ? n.cloneElement(Ne(l), { ref: l.ref }, r(l.props.children)) : r(l);
}
var Te = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
export {
  R as P,
  Xe as _
};
//# sourceMappingURL=index-CrcNWbel.js.map
